import React from 'react';
import { TableHead as MuiTableHead } from '@material-ui/core';
import TableRow from './TableRow';
import TableCell from './TableCell';

const TableHead = ({
  model,
  children,
  data,
  columnCount,
  activeName,
  onNameChange,
  sortType,
  ...props
}) => (
  <MuiTableHead {...props}>
    {data
      ? (
        <TableRow>
          {data.map((item, key) =>
            <TableCell align={item.align} key={key}>{item.data}</TableCell>)}
        </TableRow>
      )
      : React.Children.toArray(children).map(child =>
        React.cloneElement(child, { model, variant: 'head', activeName, onNameChange, sortType }))
    }
  </MuiTableHead>
)

export default TableHead;
